/* eslint-disable jsx-a11y/anchor-has-content */
import React from 'react'
import './portfolio.css'
import IMG1 from '../../assets/web1.png'
import IMG2 from '../../assets/my circiut diagram.png'
import IMG3 from '../../assets/logo.png'
import IMG4 from '../../assets/Automotive-TSR-_Traffic-Sign-Recognition_.png'
import IMG5 from '../../assets/email-responder.png'
import IMG6 from '../../assets/brand website.png'
import IMG7 from '../../assets/dashboardwebsite.png'

const data = [
  {
    id: 1,
    image:IMG1,
    title:'Hiking Website',
    github: "https://github.com/Chidinma6/Hiking-Website",
    demo: "https://mntnsit.netlify.app/"
  },
  {
    id: 2,
    image:IMG2,
    title:'Internet of Things',
    github: "https://github.com/Chidinma6/GPS-Tracker",
    demo: "https://github.com/Chidinma6/GPS-Tracker"
  },

  {
    id: 3,
    image:IMG3,
    title:'Mobile App Development',
    github: "https://github.com/Chidinma6/KidNav",
    demo: "https://drive.google.com/file/d/1-cIIJ2r2pvU5vT9w1Kszv9PU1i376u3N/view?usp=sharing"
  },
  
  {
    id: 4,
    image:IMG4,
    title:'Traffic Sign Recognition System',
    github: "https://github.com/Chidinma6/Traffic-Sign-Recognition-System",
    demo: "https://traffic-sign-recognition-system-vdyvy8xzpvf4vux2hbrkj2.streamlit.app/"
  },

  {
    id: 5,
    image:IMG5,
    title:'Automated Email Responder',
    github: "https://github.com/Chidinma6/email-responder",
    demo: "https://automatedemailresponder.netlify.app/"
  },

  {
  id: 6,
    image:IMG6,
    title:'Brand Website',
    github: "https://github.com/Chidinma6/Sales-",
    demo: "https://logosales.netlify.app"
  },

  {
    id: 7,
    image:IMG7,
    title:'Dashboard Website',
    github: "https://github.com/Chidinma6/Dashboard-Website",
    demo: "https://dashboardwc.netlify.app"
  },

]

const Porfolio = () => {
  return (
    <section id='portfolio'>
      <h5> My Recent Work</h5>
      <h2> Portfolio</h2>

      <div className="container portfolio_container">
       {
        data.map(({id,image,title,github,demo}) =>{
          return(
            <article key={id} className="portfolio_item">
              <div className="portfolio_item-image">
                <img src={image} alt={title} />
              </div>

              <h3>{title}</h3>

              <div className="portfolio_item-cta">
                <a href={github} className="btn">Github</a>
                <a href={demo} className="btn btn-primary" target="_blank" rel="noreferrer" >Live Demo </a>
              </div>
            </article>
          )
        })
       }        
      </div>
    </section>
  )
}

export default Porfolio